import { render } from "./add-account.vue?vue&type=template&id=5ce43181"
import script from "./add-account.vue?vue&type=script&lang=js"
export * from "./add-account.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__